export const PRODUCT_CLASS_LIST_ALL = 'PRODUCT_CLASS_LIST_ALL';
export const PRODUCT_CLASS_LISTED_ALL = 'PRODUCT_CLASS_LISTED_ALL';
export const PRODUCT_CLASS_VIEW = 'PRODUCT_CLASS_VIEW';
export const PRODUCT_CLASS_VIEW_LOADED = 'PRODUCT_CLASS_VIEW_LOADED';
export const PRODUCT_CLASS_SEARCH = 'PRODUCT_CLASS_SEARCH';
export const PRODUCT_CLASS_UNLOAD = 'PRODUCT_CLASS_UNLOAD';
